import { decorate } from './decorate';

export function promiseDecoratorHttp($provide) {
  'ngInject';
  $provide.decorator('$http', function ($delegate) {
    const $http = $delegate;
    const decoratedHttp = function () {
      let http = $http.apply($http, arguments);
      return decorate(http);
    };

    // $http has convenience methods such as $http.get() that we have
    // to pass through as well.
    Object.keys($http).filter(function (key) {
      return (angular.isFunction($http[key]));
    }).forEach(function (key) {
      decoratedHttp[key] = function () {

        // Apply global changes to arguments, or perform other
        // nefarious acts.

        let http = $http[key].apply($http, arguments);
        return decorate(http);
      };
    });

    return decoratedHttp;
  });
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-promise-decorator/src/promise.http.js